module.exports = __webpack_public_path__ + "static/cortado_au_lait-917bc28a79f5604ee12b3d3eee1a9e78.png";